import { useQuery } from "@tanstack/react-query";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { AppHeader } from "@/components/AppHeader";
import { ListingCard } from "@/components/ListingCard";
import { getListings, CURRENT_USER } from "@/data/listings";

export default function Saved() {
  const { data: listings = [], isLoading } = useQuery({
    queryKey: ["listings"],
    queryFn: getListings,
  });

  const saved = listings.filter(l => l.savedBy.includes(CURRENT_USER.id));

  return (
    <div className="min-h-screen pb-20 md:pb-8">
      <AppHeader />

      <div className="max-w-6xl mx-auto px-4 mt-6">
        <div className="flex items-center gap-2 mb-6">
          <Heart size={18} style={{ color: "var(--rose)" }} />
          <h1 className="text-xl font-bold">Saved Dresses</h1>
          {!isLoading && <span className="text-sm text-muted-foreground">({saved.length})</span>}
        </div>

        {isLoading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-2xl overflow-hidden">
                <Skeleton className="aspect-[3/4] w-full" />
                <div className="p-3 space-y-2">
                  <Skeleton className="h-3 w-3/4" />
                  <Skeleton className="h-3 w-1/2" />
                </div>
              </div>
            ))}
          </div>
        ) : saved.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: "var(--rose-light)" }}>
              <Heart size={24} style={{ color: "var(--rose)" }} />
            </div>
            <h3 className="font-semibold text-lg mb-2">Your wishlist is empty</h3>
            <p className="text-sm text-muted-foreground mb-6">Save dresses you love by tapping the heart icon</p>
            <Link to="/">
              <Button className="rounded-full" style={{ background: "var(--rose)", color: "white" }}>
                Discover Dresses
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {saved.map(listing => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
